import thunkMiddleware from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { localeReducer } from 'react-localize-redux';

import orders from './orders/reducers';
import orderSingle from './orderSingle/reducers';
import ordersFind from './ordersFind/reducers';
import ordersProgress from './ordersProgress/reducers';
import ordersComplete from './ordersComplete/reducers';
import settings from './settings/reducers';
import user from './user/reducers';
import finances from './finances/reducers';
import help from './help/reducers';
import updates from './updates/reducers';
import notification from './notification/reducers';

const rootReducer = combineReducers({
    locale: localeReducer,
    orders,
    orderSingle,
    ordersFind,
    ordersProgress,
    ordersComplete,
    settings,
    user,
    finances,
    help,
    updates,
    notification
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = preloadedState => {
    return createStore(
        rootReducer,
        preloadedState,
        composeEnhancers(applyMiddleware(thunkMiddleware))
    );
};

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/store.js